import axios from "axios";
export const createRecord = (collection: string, record: any) => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/api/${collection}`,
    record,
  );
};
